var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketBoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 342.02 264.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 128.96,
    y1: 247.1,
    x2: 121.62,
    y2: 298.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 161.7,
    y1: 259.98,
    x2: 157.79,
    y2: 287.41,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 175.28,
    y1: 253.54,
    x2: 172.59,
    y2: 272.39,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 228.82,
    y1: 182.34,
    x2: 245.12,
    y2: 200.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 219.37,
    y1: 157.03,
    x2: 221.21,
    y2: 173.34,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 292.18,
    y1: 122.56,
    x2: 290,
    y2: 92.4,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 245.36,
    y1: 166.11,
    x2: 233.94,
    y2: 122.49,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 250.58,
    y1: 249.57,
    x2: 276.68,
    y2: 249.57,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 151.46,
    y1: 224.2,
    x2: 174.3,
    y2: 224.2,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 257.75,
    y1: 161.59,
    x2: 293.42,
    y2: 148.35,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 281.11,
    y1: 308.42,
    x2: 281.65,
    y2: 244.28,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 168.64,
    y1: 174.8,
    x2: 179.44,
    y2: 156.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 168.17,
    y1: 225.64,
    x2: 181.01,
    y2: 240.72,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 168,
    y1: 178.93,
    x2: 171.55,
    y2: 231.47,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 286.63,
    y1: 178.93,
    x2: 290.18,
    y2: 231.47,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M287.58 15.52C273.91 4.82 256.15.52 238.84.05a130.07 130.07 0 00-60.69 13.17c-14.35 7-27.25 16.64-41 24.71-28.86 16.92-61.47 27.05-89.3 45.62S-3.53 133 .44 166.22c3.74 31.36 31.05 55.35 60.42 66.95s61.47 13.82 92.33 20.48c28.28 6.1 57.75 16 85.36 7.38 14.74-4.6 27.48-14.14 42-19.3 17.79-6.31 39.2-6.69 51.8-20.74 9.81-10.93 11.06-27.24 8.47-41.69-3-16.88-10.18-32.69-12.18-49.8-1.72-14.68 1.29-28.95.67-43.51-1.01-24.21-23.16-56.03-41.73-70.47z",
    fill: "#4b39ef",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51 191.2a34.33 34.33 0 00-32.25-9.8c-4.69 1.1-9.1 3.2-13.78 4.33a35.3 35.3 0 01-30.93-7.59 31.68 31.68 0 0017.66 19.91c-8.08-.07-15.78-3.26-23-6.84-11-5.44-22.14-12-34.45-12.43-14.48-.44-27.61 7.74-39.43 16.17a43 43 0 0129.45-4.09c22 4.91 38.19 26.64 60.65 28.49 13.17 1.08 25.78-5 37.29-11.5a85.06 85.06 0 00-9.86 17.9c9.68-8.16 25.61-4.14 35.5-12.05a22.47 22.47 0 007.36-12.18 15.26 15.26 0 000-8.83c-1-2.81-3.54-5.21-6.52-5.36",
    fill: "#4b39ef",
    opacity: 0.59,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.36 264.68a34.33 34.33 0 00-32.25-9.8c-4.69 1.1-9.1 3.2-13.78 4.33a35.3 35.3 0 01-30.93-7.59 31.68 31.68 0 0017.66 19.91c-8.08-.07-15.78-3.26-23-6.84-11-5.44-22.14-12-34.45-12.43-14.48-.44-27.61 7.74-39.43 16.17a43 43 0 0129.45-4.09c22 4.91 38.19 26.64 60.65 28.49 13.17 1.08 25.78-5 37.29-11.5a85.06 85.06 0 00-9.86 17.9c9.68-8.16 25.61-4.14 35.5-12.05a22.47 22.47 0 007.36-12.18 15.26 15.26 0 000-8.83c-1-2.81-3.54-5.21-6.52-5.36",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.36 269.37a18.31 18.31 0 00-17.22-5.23c-2.5.59-4.85 1.7-7.35 2.31a18.85 18.85 0 01-16.52-4.05 16.94 16.94 0 009.43 10.6c-4.31 0-8.42-1.75-12.29-3.65-5.9-2.91-11.82-6.44-18.4-6.64-7.72-.24-14.75 4.15-21 8.63a22.89 22.89 0 0115.72-2.18c11.75 2.62 20.4 14.22 32.39 15.21 7 .58 13.77-2.68 19.91-6.14a45.41 45.41 0 00-5.26 9.56c5.16-4.36 13.67-2.21 19-6.43a12.05 12.05 0 003.93-6.51 8.13 8.13 0 000-4.71 4.17 4.17 0 00-3.49-2.86",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.37 270.35a12.58 12.58 0 00-11.83-3.59c-1.72.4-3.34 1.17-5.06 1.58a13 13 0 01-11.35-2.78 11.65 11.65 0 006.48 7.31 20 20 0 01-8.45-2.51c-4-2-8.12-4.42-12.64-4.56-5.31-.17-10.14 2.85-14.46 5.93a15.73 15.73 0 0110.81-1.5c8.07 1.8 14 9.78 22.25 10.45 4.83.4 9.46-1.84 13.68-4.22a31.83 31.83 0 00-3.61 6.57c3.55-3 9.4-1.52 13-4.42a8.28 8.28 0 002.71-4.47 5.67 5.67 0 000-3.24 2.85 2.85 0 00-2.39-2",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.28 132.87a162.12 162.12 0 00-23.65 10 8.48 8.48 0 00-3.16 2.37 3 3 0 000 3.67c.84.86 2.2.87 3.4.81a176.09 176.09 0 0044.12-7.87 2.77 2.77 0 001.31-.69c.68-.76.35-2-.12-2.88-4.66-9.08-13.56-8.17-21.9-5.41zm65.46 39.29a1.12 1.12 0 001.16 1.57l4 .66a1.64 1.64 0 002.15-1.06c2-3.79 3.91-7.68 6.27-11.27 4.82-7.31 11.7-13.36 14.93-21.5a38.39 38.39 0 002-7.46c.71-4.09.8-8.87-2.23-11.7a2.17 2.17 0 00-1.56-.73 2.47 2.47 0 00-1.2.54c-3 2.08-7.58 4.14-9.89 7-1.82 2.29-3 5.86-4.25 8.5a136.17 136.17 0 00-8.5 22.55q-1.74 6.38-2.88 12.9z",
    fill: "#f3bd8d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.53 116.98c-1.78 2.36-3.55 4.71-5.5 6.92a55.45 55.45 0 01-6.07 5.9 2.38 2.38 0 00-.92 1.19 2.3 2.3 0 00.8 1.84c2 2.23 4.07 4.38 6.25 6.42a4.35 4.35 0 006.16 1c10.27-5.18 19-12.92 29-18.62a3.63 3.63 0 011.37-.55 3.7 3.7 0 011.57.25 203.4 203.4 0 0122.64 8.6 4.65 4.65 0 002.07.56 4.31 4.31 0 002.27-1.07 74.52 74.52 0 009.21-8.08 3.13 3.13 0 001-1.67 3.07 3.07 0 00-.86-2.09 62.53 62.53 0 00-19.87-17.12 46.11 46.11 0 00-20.24-6c-5.28-.18-13.14.35-17 4.62-1.91 2.13-3.2 5-4.67 7.39a126.72 126.72 0 01-7.21 10.51z",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.38 190.46c-1.78 2.36-3.55 4.71-5.5 6.92a55.45 55.45 0 01-6.07 5.9 2.38 2.38 0 00-.92 1.19 2.3 2.3 0 00.8 1.84c2 2.23 4.07 4.38 6.25 6.42a4.35 4.35 0 006.16 1c10.27-5.18 19-12.92 29-18.62a3.63 3.63 0 011.37-.55 3.7 3.7 0 011.57.25 203.4 203.4 0 0122.64 8.6 4.65 4.65 0 002.07.56 4.31 4.31 0 002.27-1.07 74.52 74.52 0 009.21-8.08 3.13 3.13 0 001-1.67 3.07 3.07 0 00-.86-2.09 62.53 62.53 0 00-19.87-17.12 46.11 46.11 0 00-20.24-6c-5.28-.18-13.14.35-17 4.62-1.91 2.13-3.2 5-4.67 7.39a126.72 126.72 0 01-7.21 10.51z",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.25 97.52c2.78-.57 5.44-1.65 8.23-2.12 7.82-1.32 15.69 2.24 23.61 1.93a1.53 1.53 0 001.22-.44 1.55 1.55 0 00.19-1l-.3-7.41a16.31 16.31 0 00-1.1-6.3c-1.83-4-6.6-5.84-10.95-5.58s-8.39 2.21-12.3 4.13l-9.7 4.72c-2.23 1.1-5.27 2.24-6.66 4.48-.88 1.44-1.41 5.1-.39 6.49 1.43 2.02 6.12 1.46 8.15 1.1z",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.1 171c2.78-.57 5.44-1.65 8.23-2.12 7.82-1.32 15.69 2.24 23.61 1.93a1.53 1.53 0 001.22-.44 1.55 1.55 0 00.19-1l-.3-7.41a16.31 16.31 0 00-1.1-6.3c-1.83-4-6.6-5.84-10.95-5.58s-8.39 2.21-12.3 4.13l-9.7 4.72c-2.23 1.1-5.27 2.24-6.66 4.48-.88 1.44-1.41 5.1-.39 6.49 1.43 2.02 6.12 1.46 8.15 1.1z",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#e)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M269.95 50.23a2.39 2.39 0 01.48 1.49 1.41 1.41 0 01-1.09.94c-.49.12-1 .09-1.5.17-1.88.32-3.1 2.07-4.21 3.62s-2.65 3.17-4.55 3a11.31 11.31 0 01-2.7-1 9 9 0 00-7.33 1c-1 .58-2.19 1.32-3.36 1a3.45 3.45 0 01-2.16-2.27 13 13 0 01-.76-5.23 4.58 4.58 0 01.36-1.91c.46-1 1.44-1.5 2.15-2.28a9.79 9.79 0 001.38-2.14 60 60 0 014-6.37c2-2.83 4.57-5.65 8-6.4a11.12 11.12 0 018.2 1.88c2.14 1.38 3.17 4.12 3.34 6.62s-1.59 5.27-.25 7.88z",
    fill: "#f3bd8d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.37 37.36c.88 1 1.82 2.22 1.36 3.44a2.7 2.7 0 01-2.7 1.42c-2.15-.1-4-1.56-5.89-2.5a13.16 13.16 0 00-7-1.27 1.8 1.8 0 00-.8.22 2 2 0 00-.62.86l-2.46 5.32c-.5-.41-.41-1.18-.33-1.82s-.06-1.48-.69-1.64a1.17 1.17 0 00-.75.13 2.92 2.92 0 00-1.52 3.44c.11.34.25.77 0 1a.94.94 0 01-.62.11c-1.06 0-1.85.92-2.56 1.71s-1.68 1.59-2.7 1.33a.9.9 0 01-.57-.37 1.26 1.26 0 010-.9l.43-2.34a3.4 3.4 0 00-.09-2.23 4.15 4.15 0 00-1.86-1.42c-.7-.39-1.42-1-1.41-1.78a2 2 0 011.39-1.61 22.1 22.1 0 002.13-.7 4.84 4.84 0 01.21-3.92 5 5 0 012.6-1.61 37.81 37.81 0 017.49-1.71 14 14 0 016.27.38 17.75 17.75 0 012.6 1.25c0 .41 3.91 2.17 4.4 2.45a13.09 13.09 0 013.69 2.76z",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.73 34.52l-.1-2.6a5.74 5.74 0 00-3.12-5.67 23.14 23.14 0 00-5.49-3.26 12.28 12.28 0 00-10.69 1.17 17.51 17.51 0 00-5.53 6.24 4.42 4.42 0 01-1.58 1.93 4.29 4.29 0 01-1.74.34c-3.51.18-7.29.29-10.2-1.66a2.8 2.8 0 00-1.55-.67 1.55 1.55 0 00-1.1 2.09 3.63 3.63 0 002 1.81c3.29 1.59 7.09 1.56 10.75 1.72 6.08.28 12.12 1.19 18.16 2a60.74 60.74 0 007.74.64c2.25.02 2.53-2.08 2.45-4.08z",
    fill: "#4b39ef"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.58 108l-.1-2.6a5.74 5.74 0 00-3.12-5.67 23.14 23.14 0 00-5.49-3.26 12.28 12.28 0 00-10.69 1.17 17.51 17.51 0 00-5.53 6.24 4.42 4.42 0 01-1.58 1.93 4.29 4.29 0 01-1.74.34c-3.51.18-7.29.29-10.2-1.66a2.8 2.8 0 00-1.55-.67 1.55 1.55 0 00-1.1 2.09 3.63 3.63 0 002 1.81c3.29 1.59 7.09 1.56 10.75 1.72 6.08.28 12.12 1.19 18.16 2a60.74 60.74 0 007.74.64c2.25.02 2.53-2.08 2.45-4.08z",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#f)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M246.35 59.35c-1.91 6.57-9.11 10.32-11.76 16.62-.63 1.5-1 3.09-1.49 4.63-1.92 5.81-6 10.65-8.33 16.31-.81 2-1.47 4.15-3.14 5.48a7 7 0 01-4.79 1.28c-6.26-.39-11.08-6.16-17.29-7-3.69-.5-7.36.81-10.86 2.11a105.68 105.68 0 012.72-17.47 36.71 36.71 0 018.1-15.55c1.95-2.1 4.22-3.89 6.08-6.07 1.15-1.35 7.85 2.2 9.16 1 1.1-1-3.31-6.81-2-7.46a57.42 57.42 0 0113.88-4.21c5.09-1 10.67-1.87 15.25.59a10.12 10.12 0 015 6 7.84 7.84 0 01-1.82 7.49",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M274.6 107.52c.55.22 1.11.41 1.67.62a15.91 15.91 0 015.05 3.17 23.73 23.73 0 013.48 3.88 9.32 9.32 0 01.42 9.77 2.14 2.14 0 01-1.16 1.06 2.45 2.45 0 01-2.14-.86 23.91 23.91 0 01-4.94-6.2c-1-1.82-2.2-4.07-4.28-4.12a8.32 8.32 0 01-1.41 0 3.27 3.27 0 01-1.31-.76c-5-4.07-9.78-8.59-15.69-11.14-2.82-1.22-6-2.1-7.82-4.6a1.1 1.1 0 01-.32-.82c.43-2.79 3.72-6.76 6.7-6.55 2.36.18 3.43 2.07 5.06 3.41 1.94 1.6 16.58 13.14 16.69 13.14z",
    fill: "#f3bd8d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M205.46 84.26c-7.48.15-15-.65-22.41.67a39.48 39.48 0 00-19.69 9.78 3 3 0 01-1.45.9c-1 .16-1.83-.74-2.35-1.61-2.4-4-2.39-9-2-13.66.46-5.5 1.43-11.17 4.53-15.74a13.27 13.27 0 013.92-3.94 17.13 17.13 0 017.65-2.1c8.9-.75 17.79.9 26.7 1.38a19.22 19.22 0 007.56-.69c3.56-1.29 6.15-4.37 9.37-6.35 4.08-2.51 9-3.18 13.76-3.58a20.92 20.92 0 018 .42c2.55.79 4.92 2.71 5.51 5.32s-.64 5.19-1.91 7.51a23.24 23.24 0 01-3.65 5.28c-2.39 2.41-5.54 3.8-8.36 5.63-2.4 1.57-3.73 3.55-5.69 5.49-4.64 4.55-13.38 5.16-19.49 5.29z",
    fill: "#4b39ef"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M244.31 157.74c-7.48.15-15-.65-22.41.67a39.48 39.48 0 00-19.69 9.78 3 3 0 01-1.45.9c-1 .16-1.83-.74-2.35-1.61-2.4-4-2.39-9-2-13.66.46-5.5 1.43-11.17 4.53-15.74a13.27 13.27 0 013.92-3.94 17.13 17.13 0 017.65-2.1c8.9-.75 17.79.9 26.7 1.38a19.22 19.22 0 007.56-.69c3.56-1.29 6.15-4.37 9.37-6.35 4.08-2.51 9-3.18 13.76-3.58a20.92 20.92 0 018 .42c2.55.79 4.92 2.71 5.51 5.32s-.64 5.19-1.91 7.51a23.24 23.24 0 01-3.65 5.28c-2.39 2.41-5.54 3.8-8.36 5.63-2.4 1.57-3.73 3.55-5.69 5.49-4.64 4.55-13.38 5.16-19.49 5.29z",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#g)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M215.03 170.15a35.06 35.06 0 00-3.16 9.22c-.21 1.13-.3 2.49.57 3.23a3.45 3.45 0 002.24.57l21.28.46a2.14 2.14 0 001.39-.3 1.65 1.65 0 00.48-1.29c0-2.08-1.54-3.88-3.32-5s-3.84-1.64-5.68-2.62a2.77 2.77 0 01-.84-.63c-.91-1.12.16-2.68.67-4a1.09 1.09 0 00.1-.53 1 1 0 00-1-.73c-1.44-.08-2.46 1.51-3.88 1.75a4.51 4.51 0 01-1.85-.22c-1.08-.28-7-2.85-7 .09zm-90.15-30.26a7.61 7.61 0 00-3.62.89 7.8 7.8 0 00-2.29 2.79 96.25 96.25 0 00-5.48 11.17c-.71 1.73-1.35 3.77-.41 5.38a4.25 4.25 0 004.17 1.77 11.52 11.52 0 004.4-1.78 22.86 22.86 0 005.28-3.92c1.23-1.32 2.29-3 4-3.54 1.3-.43 2.81-.16 4-.83a.92.92 0 00.48-.51c.11-.42-.3-.78-.67-1l-1.59-1.09a5.12 5.12 0 01-1.6-1.43c-1.47-2.29 1.22-5 .18-7.14-.9-1.85-5.11-.88-6.85-.76z",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M253.88 243.63a35.06 35.06 0 00-3.16 9.22c-.21 1.13-.3 2.49.57 3.23a3.45 3.45 0 002.24.57l21.28.46a2.14 2.14 0 001.39-.3 1.65 1.65 0 00.48-1.29c0-2.08-1.54-3.88-3.32-5s-3.84-1.64-5.68-2.62a2.77 2.77 0 01-.84-.63c-.91-1.12.16-2.68.67-4a1.09 1.09 0 00.1-.53 1 1 0 00-1-.73c-1.44-.08-2.46 1.51-3.88 1.75a4.51 4.51 0 01-1.85-.22c-1.08-.28-7-2.85-7 .09z",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#h)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.73 213.37a7.61 7.61 0 00-3.62.89 7.8 7.8 0 00-2.29 2.79 96.25 96.25 0 00-5.48 11.17c-.71 1.73-1.35 3.77-.41 5.38a4.25 4.25 0 004.17 1.77 11.52 11.52 0 004.4-1.78 22.86 22.86 0 005.28-3.92c1.23-1.32 2.29-3 4-3.54 1.3-.43 2.81-.16 4-.83a.92.92 0 00.48-.51c.11-.42-.3-.78-.67-1L172 222.7a5.12 5.12 0 01-1.6-1.43c-1.47-2.29 1.22-5 .18-7.14-.9-1.85-5.11-.88-6.85-.76z",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#i)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M237.83 57.79c-.05-.31.49-.17.68.08 3.38 4.73 5.25 10.34 7.44 15.72s4.89 10.81 9.43 14.44c1.86 1.5 4.21 3 4.33 5.41.08 1.86-1.28 3.43-2.55 4.78-3 3.17-6.53 6.58-10.87 6.42-.46-1.7-2.07-2.77-3.42-3.89-5.29-4.37-7.84-11.21-12.39-16.35-2.26-2.55-5.07-4.78-6.36-7.93-1.73-4.26-.25-9.13 1.74-13.27a18.33 18.33 0 013.83-5.7 7.93 7.93 0 016.27-2.28 5.12 5.12 0 014.49 4.5",
    fill: "#4b39ef"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M276.68 131.27c-.05-.31.49-.17.68.08 3.38 4.73 5.25 10.34 7.44 15.72s4.89 10.81 9.43 14.44c1.86 1.5 4.21 3 4.33 5.41.08 1.86-1.28 3.43-2.55 4.78-3 3.17-6.53 6.58-10.87 6.42-.46-1.7-2.07-2.77-3.42-3.89-5.29-4.37-7.84-11.21-12.39-16.35-2.26-2.55-5.07-4.78-6.36-7.93-1.73-4.26-.25-9.13 1.74-13.27a18.33 18.33 0 013.83-5.7 7.93 7.93 0 016.27-2.28 5.12 5.12 0 014.49 4.5",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#j)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M324.04 206.52c-10.35 7-33 11.78-33 11.78l-129.53.55-.27-17-.24-18.33c2.75-.55 127.32-2.21 127.32-2.21A65.54 65.54 0 01325.26 194c6.24 4.52 4.18 8.81-1.22 12.52z",
    fill: "#4b39ef"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M362.89 280c-10.35 7-33 11.78-33 11.78l-129.53.55-.55-16.94h.28c7.1-.28 127-1 127-1a122.46 122.46 0 0135.8 5.61z",
    transform: "translate(-38.85 -73.48)",
    fill: "url(#k)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b39ef",
    d: "M161 183.52l-13.51-19.37h13.86l29.96 18.75-30.31.62zm.68 34.68l-13.51 19.06h13.86l29.96-18.75-30.31-.31z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M161 183.52l-13.51-19.37h13.86l29.96 18.75-30.31.62z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M161.68 218.2l-13.51 19.06h13.86l29.96-18.75-30.31-.31z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M166.45 181.37h5.98v37.5h-5.98z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M285.07 181.37h5.98v37.5h-5.98z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketBoy);
export default __webpack_public_path__ + "static/media/rocket_boy.546d8d3dc69e5d7d9b4fd45d0f3d1912.svg";
export { ForwardRef as ReactComponent };